<template>
  <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="16.2" viewBox="0 0 18 16.2">
    <path class="a"
          d="M18.3,9H5.7A2.7,2.7,0,0,0,3,11.7v5.4H6.6v3.6H17.4V17.1H21V11.7A2.7,2.7,0,0,0,18.3,9Zm-2.7,9.9H8.4V14.4h7.2Zm2.7-6.3a.9.9,0,1,1,.9-.9A.9.9,0,0,1,18.3,12.6Zm-.9-8.1H6.6V8.1H17.4Z"
          transform="translate(-3 -4.5)"/>
  </svg>
</template>

<script>
export default {
  name: "Printer"
}
</script>

<style scoped>
.icon .a {
  fill: #00a2f8;
}
</style>